import { render } from "./AddressProgramOrderTabProto.vue?vue&type=template&id=1a4e620e"
import script from "./AddressProgramOrderTabProto.vue?vue&type=script&lang=js"
export * from "./AddressProgramOrderTabProto.vue?vue&type=script&lang=js"

import "./AddressProgramOrderTabProto.vue?vue&type=style&index=0&id=1a4e620e&lang=scss"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__